import { FC } from 'react'
import { useRouter } from 'next/router'
import useLocale from '@/utils/useLocale'
import styles from './index.module.less'
import { NOT_VERIFIED } from '@/utils/constants'
import Bg403 from '@/assets/403.svg'

type Props = {
  code: '403' | '404' | '500' | typeof NOT_VERIFIED
  message?: string
}

const MobileException: FC<Props> = (props) => {
  const t = useLocale()
  const router = useRouter()

  const errorMap = {
    '403': {
      title: t['403.title'],
      subTitle: props?.message || t['403.subtitle']
    },
    '404': {
      title: t['404.title'],
      subTitle: props?.message || t['404.subtitle']
    },
    '500': {
      title: t['500.title'],
      subTitle: props?.message || t['500.subtitle']
    },
    [NOT_VERIFIED]: {
      bg: <Bg403 />,
      title: t['403.title'],
      subTitle: (
        <div style={{ fontSize: '16px', textAlign: 'center' }}>
          <div>{t['exception.not.verified1']}</div>
          <div>{t['exception.not.verified2']}</div>
        </div>
      )
    }
  }

  const error = errorMap[props.code]
  const is500WithRetry = props.code === '500' && !router.pathname.startsWith('/500')
  const buttonProps = is500WithRetry
    ? {
        onClick: () => {
          router.reload()
        },
        children: t['exception.retry']
      }
    : {
        onClick: () => {
          router.replace('/board')
        },
        children: t['back.home']
      }

  return (
    <div className={styles.wrapper}>
      <div className={styles.result}>
        <div className={styles[`bg${props.code}`]}></div>
        <div className={styles.title}>{error.title}</div>
        <div className={styles.subtitle}>{error.subTitle}</div>
        <div className={styles.btn} {...buttonProps}></div>
      </div>
    </div>
  )
}

export default MobileException
